<footer class="border-t border-subtle bg-surface-muted px-4 py-6 sm:px-6">
  <div class="grid gap-6 sm:grid-cols-12">
    <div class="sm:col-span-8">
      <p class="text-lg font-semibold uppercase tracking-wide text-text">Numerical</p>
      <p class="mt-2 text-sm leading-6 text-text-muted">
        Numbers matter<br />
        Numbers bring objectivity<br />
        Numbers give us a better sense of time, space, age, size, speed, proportion, value,
        impact...<br />
        Numbers measure, numbers compete<br />
        Numbers make some immortal and when there is no more count, we realize we are mortal<br />
        Numbers speak loud and clear<br /><br />
        <i>Numerical - The Universe in numbers</i><br /><br />
      </p>
      <p class="text-sm text-text-muted">Release W-2.0 dated: 07-Mar-2026</p>
      <p class="text-sm text-text-muted">&copy; 2016-2026 Yatin Dhareshwar</p>
    </div>

    <div class="sm:col-span-4">
      <nav aria-label="Footer">
        <ul class="space-y-2">
          <li>
            <a href="#" class="text-sm text-secondary no-underline hover:underline"
              >Documentation</a
            >
          </li>
          <li>
            <a href="#" class="text-sm text-secondary no-underline hover:underline"
              >Privacy Policy</a
            >
          </li>
        </ul>
      </nav>
    </div>
  </div>
</footer>
